'use client';
import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import HeroSection from './HeroSection';
import ClimateRecommendation from './ClimateRecommendation';
import PriceMoversSection from './PriceMoversSection';
import SeasonalPicksSection from './SeasonalPicksSection';
import TrendingSection from './TrendingSection';
import CategoryQuickLinks from './CategoryQuickLinks';
import AIChatFab from '@/components/AIChatFab';

export default function HomePageClient() {
  const [lang, setLang] = useState<'en' | 'ta'>('en');
  const [climateVisible, setClimateVisible] = useState(true);

  return (
    <AppLayout activeRoute="/" lang={lang} onLangToggle={() => setLang(l => l === 'en' ? 'ta' : 'en')}>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 xl:px-10 2xl:px-16 space-y-10 py-6">
        <HeroSection lang={lang} />
        {climateVisible && (
          <ClimateRecommendation lang={lang} onDismiss={() => setClimateVisible(false)} />
        )}
        <CategoryQuickLinks lang={lang} />
        <PriceMoversSection lang={lang} />
        <SeasonalPicksSection lang={lang} />
        <TrendingSection lang={lang} />
      </div>
      <AIChatFab />
    </AppLayout>
  );
}